import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { FaApple, FaBus, FaCarSide, FaGooglePlay, FaHandshake, FaHouse, FaLandmark, FaMapLocationDot, FaMapPin, FaMotorcycle, FaShieldHalved, FaStar, FaStore, FaTrophy, FaUsers, FaUtensils } from "react-icons/fa6";
import "./allMappers.css";
import "../style01.css";
import "../style02.css";
import "../AllMetuaaEat/metuaaEat.css";
import "../AllMetuaa/metuaa.css";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import PageBanner from "../../../components/pageBanner";
import m1 from "../../../assets/images/mapping.jpeg";
import m2 from "../../../assets/images/mappers4.png";
import heroPhoto from "../../../assets/images/mappers3.png";
import mapperImage from "../../../assets/images/image-mapper.png";
import eatImage from "../../../assets/images/metuaa-eat.png";
import travelImage from "../../../assets/images/travel hub 6.png";
import driverImage from "../../../assets/images/all-slider/driver-slide-cameroon.png";
import enterpriseImage from "../../../assets/images/all-slider/image-entreprise.png";
import mplusImage from "../../../assets/images/New-2025-Kia-Carnival-6.avif";
import phoneImage from "../../../assets/images/lastimage.png";
import card1 from "../../../assets/images/1card.png";
import card2 from "../../../assets/images/2card.png";
import card3 from "../../../assets/images/3card.png";
import offer_1 from "../../../assets/images/offer_1.png";
import offer_2 from "../../../assets/images/offer_2.png";


/* ─────────────────────────── Icônes ─────────────────────────── */

function CameraIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M4 8.5h3L9 6h6l2 2.5h3a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 17v-7A1.5 1.5 0 0 1 4 8.5Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <circle cx="12" cy="13.5" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

function CarIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M5 11.5 6.6 7a2 2 0 0 1 1.9-1.4h7a2 2 0 0 1 1.9 1.4L19 11.5M5 11.5h14M5 11.5v4.7h1.9v1.6a1 1 0 0 0 1 1H9a1 1 0 0 0 1-1v-1.6h4v1.6a1 1 0 0 0 1 1h1.1a1 1 0 0 0 1-1v-1.6H19v-4.7M7.5 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm9 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function BoxIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M12 2.8 21 7.5v9L12 21.2 3 16.5v-9L12 2.8Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M3.4 7.3 12 12l8.6-4.7M12 12v9.2" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

function StoreIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M4 9.5 5 4h14l1 5.5M4 9.5a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0M5.5 9.8V20h13V9.8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5 20v-5.5h5V20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

function CoinIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M12 7.2v9.6M9.6 9.4c0-1 1-1.7 2.4-1.7 1.5 0 2.6.8 2.6 1.9 0 2.6-5 1.2-5 3.8 0 1.1 1.1 1.9 2.6 1.9 1.4 0 2.4-.7 2.4-1.7" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

function ChartIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M4 20V10M11 20V4M18 20v-7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M3 20h18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function TrophyIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M7 4h10v4a5 5 0 0 1-10 0V4Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M7 5H4.5A1.5 1.5 0 0 0 3 6.5 3.5 3.5 0 0 0 6.5 10H7M17 5h2.5A1.5 1.5 0 0 1 21 6.5 3.5 3.5 0 0 1 17.5 10H17" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 12.5v3M9 20h6M9.5 18.5c0-2 5-2 5 0" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function TargetIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <circle cx="12" cy="12" r="8.4" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="1.6" fill="currentColor" />
    </svg>
  );
}

function TagIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="m20 12-8 8-9-9V4h7l10 8Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" />
    </svg>
  );
}

function CheckIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M4 12.5 9.5 18 20 6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function WalletIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path d="M3.5 7.5h14a2.5 2.5 0 0 1 2.5 2.5v7a2.5 2.5 0 0 1-2.5 2.5h-14A2.5 2.5 0 0 1 1 17V7.5Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M3.5 7.5 13 3l3 3.4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="16.3" cy="13.5" r="1.4" fill="currentColor" />
    </svg>
  );
}

/* ─────────────────────────── Données ─────────────────────────── */

const usageCards = [
  { icon: CarIcon, titleId: "mapper.usage.drivers.title", textId: "mapper.usage.drivers.text" },
  { icon: BoxIcon, titleId: "mapper.usage.delivery.title", textId: "mapper.usage.delivery.text" },
  { icon: StoreIcon, titleId: "mapper.usage.shops.title", textId: "mapper.usage.shops.text" },
];

const earningsCards = [
  { icon: CoinIcon, titleId: "mapper.earnings.commissions.title", textId: "mapper.earnings.commissions.text" },
  { icon: ChartIcon, titleId: "mapper.earnings.passive.title", textId: "mapper.earnings.passive.text" },
  { icon: TrophyIcon, titleId: "mapper.earnings.bonus.title", textId: "mapper.earnings.bonus.text" },
];

const howItWorksSteps = [
  {
    key: "choose",
    bg: card1,
    title: "Repérez & Cartographiez ",
    text: "Ajoutez sur la carte vos points d'intérêt locaux (boutiques, carrefours connus, repères populaires).",
  },
  {
    key: "request",
    bg: card2,
    title: "Nommez avec précision",
    text: "Donnez-leur les vrais noms utilisés par la communauté sur le terrain.",
  },
  {
    key: "ride",
    bg: card3,
    title: "Touchez vos commissions ",
    text: "Recevez des gains automatiquement à chaque fois que votre point géolocalisé est utilisé pour une course ou une livraison ! ",
  },
];

const services = [
  {
    key: "mapper",
    image: mapperImage,
    icon: FaMapPin,
    title: "Metua'a Mappers",
    text: "Numérisez votre quartier, validez des lieux et gagnez de l'argent en aidant la communauté à mieux se déplacer.",
    href: "/metuaa-mapper",
  },
  {
    key: "eat",
    image: eatImage,
    icon: FaUtensils,
    title: "Metua'a Eats",
    text: "Commandez vos plats préférés et faites-vous livrer à domicile ou au bureau, en toute fraîcheur.",
    href: "/metuaa-eat",
  },
  {
    key: "travel",
    image: travelImage,
    icon: FaBus,
    title: "Metua'a Travel Hub",
    text: "Covoiturage et voyages interurbains : réservez votre place auprès des compagnies de transport.",
    href: "/metuaa-travel-hub",
  },
  {
    key: "driver",
    image: driverImage,
    icon: FaMotorcycle,
    title: "Conduire avec Metua'a",
    text: "Soyez votre propre patron. Gagnez de l'argent en conduisant quand vous voulez.",
    href: "/all-driver",
  },
  {
    key: "enterprise",
    image: enterpriseImage,
    icon: FaHandshake,
    title: "Metua'a Entreprise",
    text: "Simplifiez les déplacements de vos collaborateurs et gérez vos opérations avec des outils sécurisés.",
    href: "/all-enterprise",
  },
  {
    key: "mplus",
    image: mplusImage,
    icon: FaCarSide,
    title: "Programme M+",
    text: "Acquérez votre propre véhicule grâce au programme M+ et maximisez vos revenus quotidiens.",
    href: "/mplus-program",
  },
];

export const featureCards = [
  {
    key: "africa",
    icon: FaUsers,
    title: "Une solution 100% africaine",
    text: "Conçue par Africa Systems pour le contexte camerounais : motos, voitures, trucks et services adaptés à vos réalités.",
  },
  {
    key: "secure",
    icon: FaShieldHalved,
    title: "Paiements sécurisés et à vie",
    text: "Retirez vos gains via Mobile Money en toute sécurité grâce à notre Wallet intégré. Cartographiez une fois, touchez des commissions à vie sur chaque utilisation !",
  },
  {
    key: "rewards",
    icon: FaTrophy,
    title: "Récompenses Metua'a",
    text: "Programme de fidélité et bonus : chaque course et chaque mission vous rapporte des avantages exclusifs.",
  },
];

const mapperProfiles = [
  "mapper.who.profile.student",
  "mapper.who.profile.driver",
  "mapper.who.profile.merchant",
  "mapper.who.profile.delivery",
  "mapper.who.profile.taxi",
  "mapper.who.profile.moto",
  "mapper.who.profile.citizen",
];

const mapperFilters = [
  { id: "all", label: "mapper.categories.all", icon: FaStar },
  { id: "quartiers", label: "mapper.categories.quartiers", icon: FaHouse },
  { id: "commerces", label: "mapper.categories.commerces", icon: FaStore },
  { id: "transport", label: "mapper.categories.transport", icon: FaBus },
  { id: "restaurants", label: "mapper.categories.restaurants", icon: FaUtensils },
  { id: "services", label: "mapper.categories.services", icon: FaLandmark },
];

/* ─────────────────────────── Page ─────────────────────────── */

const IconArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M9.652 2.65 8.426 3.876l3.258 3.258H1v1.728h10.684L8.426 12.12l1.226 1.226L15 7.998 9.652 2.65z" />
  </svg>
);

export default function AllMapper() {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const navigate = useNavigate();
  const [activeMapperFilter, setActiveMapperFilter] = useState("all");

  return (
    <div id="__next">
      <span data-testid="core-ui-theme-provider" className="sc-dGCmGc cukWQg">
        <Header />
        <PageBanner
                      image={heroPhoto}
                      whiteText={t("metuaa.slider.title")}
                      description={t("metuaa.slider.description")}

                      showSearch
                      searchPlaceholder={t("mapper.hero.search.placeholder")}
                      searchButtonText={t("mapper.hero.search.button")}
                      showButton
                      buttonText={t("mapper.hero.cta.join")}
                      buttonHref="/mapper/rejoindre"
                     
                    />
                    

        <main className="mapper-page">

        {/* ── FILTRES ── */}
          <section className="food-filters-section" aria-label="Catégories de lieux">
            <div className="filters-scroll">
              {mapperFilters.map(({ id, label, icon: Icon }) => (
                <button
                  key={id}
                  type="button"
                  className={`filter-chip${activeMapperFilter === id ? " active" : ""}`}
                  aria-pressed={activeMapperFilter === id}
                  onClick={() => setActiveMapperFilter(id)}
                >
                  <Icon aria-hidden="true" />
                  {t(label)}
                </button>
              ))}
            </div>
          </section>

          <section className="section">
            <div className="page-shell mapper-what-layout">
              <div className="mapper-what-media">
                <img src={m2} alt="" className="mapper-what-image" />
              </div>
              <div className="mapper-narrow mapper-what-copy">
                <p className="mapper-eyebrow">Metua'a Mappers</p>
                <h2 className="mapper-section-title">Premier réseau de cartographie participative et citoyenne au Cameroun</h2>
               <p className="mapper-body">Trop de livreurs et de chauffeurs se perdent parce que certains lieux n'existent pas sur les cartes classiques. En ajoutant les vrais lieux et les appellations connues de tous sur Metua'a, chaque destination devient facile à trouver.</p>
              </div>
            </div>
          </section>


          {/* je gagne quoi */}
          <section className="section">
            <div className="page-shell">
              <p className="mapper-eyebrow">Je gagne quoi ?</p>
              <h2 className="mapper-section-title">Chaque point d'intérêt devient une source de revenus à vie</h2>
              <p className="mapper-lede">Oui oui, à vie !</p>
              <div className="mapper-card-grid mapper-card-grid-earnings">
                <article className="mapper-card mapper-card-earnings">
                  <span className="mapper-card-icon" aria-hidden="true">
                    <CoinIcon />
                  </span>
                  <h3>Commissions à chaque utilisation</h3>
                  <p>Chaque fois qu'une course ou une livraison utilise un repère que vous avez cartographié, vous touchez une commission sur votre portefeuille Metua'a.</p>
                </article>
                <article className="mapper-card mapper-card-earnings">
                  <span className="mapper-card-icon" aria-hidden="true">
                    <ChartIcon />
                  </span>
                  <h3>Revenus passifs</h3>
                  <p>Plus vos points sont fréquentés (grands carrefours, marchés, snacks, pharmacies), plus vous gagnez au quotidien.</p>
                </article>
                <article className="mapper-card mapper-card-earnings">
                  <span className="mapper-card-icon" aria-hidden="true">
                    <TrophyIcon />
                  </span>
                  <h3>Bonus &amp; challenges</h3>
                  <p>Participez aux défis du mois ("Mapper de la semaine", "Meilleur Mapper de Douala/Yaoundé") et décrochez des primes exclusives.</p>
                </article>
              </div>
            </div>
          </section>

          {/* ══════════════════ SERVICES ══════════════════ */}
          {/* <section className="metuaa-services-section">
            <div className="page-shell">
              <h2 className="metuaa-services-title">
                Un écosystème, <mark>tous vos services</mark>
              </h2>
              <p className="metuaa-services-subtitle">
                Découvrez les services Metua'a et choisissez celui qui vous ressemble.
              </p>
              <div className="metuaa-services-grid">
                {services.map((service) => (
                  <a key={service.key} href={service.href} className="metuaa-service-card">
                    <div className="metuaa-service-image">
                      <img src={service.image} alt={service.title} loading="lazy" decoding="async" />
                    </div>
                    <div className="metuaa-service-body">
                      <span className="metuaa-service-icon" aria-hidden="true">
                        <service.icon />
                      </span>
                      <h3>{service.title}</h3>
                      <p>{service.text}</p>
                      <span className="metuaa-service-link">
                        Découvrir <FaMapLocationDot aria-hidden="true" />
                      </span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </section> */}

          {/* ══════════════════ HOW IT WORKS ══════════════════ */}
          <section className="how-it-works-section" data-qa="how-it-works-section">
            <div className="how-it-works-content">
              <h3 className="how-it-works-eyebrow">Comment ça marche ?</h3>
              <h2 className="how-it-works-title">Simple et rapide !</h2>
              <div className="how-it-works-grid">
                {howItWorksSteps.map((step) => (
                  <article key={step.key} className="how-it-works-card" style={{ backgroundImage: `url(${step.bg})` }}>
                    <h5 className="how-it-works-card-title">{step.title}</h5>
                    <p className="how-it-works-card-text">{step.text}</p>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ══════════════════ FEATURE CARDS ══════════════════ */}
          <section className="feature-cards-section">
            <div className="page-shell">
              <h2 className="feature-cards-title">Pourquoi choisir Metua'a ?</h2>
              <div className="feature-cards-grid">
                {featureCards.map((card) => (
                  <article key={card.key} className="feature-card">
                    <card.icon aria-hidden="true" className="feature-card-icon" />
                    <h3>{card.title}</h3>
                    <p>{card.text}</p>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ══════════════════ OFFERS ══════════════════ */}
          <section
            className="all-page-section sc-cd975d71-0 fJfYVy sc-4d039203-0 iaLMvL"
            data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Up"
            data-tracking-action="view"
            data-tracking-category="TextImageModule"
          >
            <div className="sc-eNSrOW kusvag">
              <div
                className="sc-satoz iYojpr"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "24px",
                  width: "100%",
                }}
              >
                {/* Colonne 1 : Card Package Famille */}
                <div className="offer-card-col">
                  <div className="cardOffer" style={{ backgroundImage: `url(${offer_1})` }}>
                    <div className="cardOffer-overlay">
                      <p className="cardOffer-label">{t("home.offers.family.label")}</p>
                      <h3 className="cardOffer-title">{t("home.offers.family.title")}</h3>
                      <div className="cardOffer-code">
                        <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                        <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                      </div>
                      <button className="cardOffer-button">
                        {t("home.offers.discover")}
                        <IconArrowRight />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Colonne 2 : Card Package Entreprise */}
                <div className="offer-card-col">
                  <div className="cardOffer" style={{ backgroundImage: `url(${offer_2})` }}>
                    <div className="cardOffer-overlay">
                      <p className="cardOffer-label">{t("home.offers.business.label")}</p>
                      <h3 className="cardOffer-title">{t("home.offers.business.title")}</h3>
                      <div className="cardOffer-code">
                        <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                        <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                      </div>
                      <button type="button" className="cardOffer-button">
                        <span>{t("home.offers.discover")}</span>
                        <IconArrowRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ══════════════════ DOWNLOAD APP ══════════════════ */}
          <section className="download-app-section" data-qa="download-app-section">
            <div className="page-shell">
              <div className="download-app-layout">
                <div className="download-app-info">
                  <h3 className="download-app-title">Téléchargez l'application</h3>
                  <p className="download-app-subtitle">Tous les services Metua'a, où que vous soyez !</p>
                  <div className="download-app-stores">
                    <a className="store-badge" href="#" aria-label="Accéder à iOS App Store" data-qa="download-app-section-ios-link">
                      <FaApple aria-hidden="true" />
                      <span>App Store</span>
                    </a>
                    <a className="store-badge" href="#" aria-label="Accéder à Google Play Store" data-qa="download-app-section-android-link">
                      <FaGooglePlay aria-hidden="true" />
                      <span>Google Play</span>
                    </a>
                  </div>
                </div>
                <div className="download-app-visual">
                  <img src={phoneImage} alt="Aperçu de l'application Metua'a" loading="lazy" decoding="async" />
                </div>
              </div>
            </div>
          </section>

        
        </main>

        <Footer />
      </span>
    </div>
  );
}
